import { useState } from "react";
import { Link } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { LogIn } from "lucide-react";
const NavBar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const role = secureLocalStorage.getItem("role");
  // console.log(role);

  const routeClear = () => {
    if (role !== "hospital") {
      secureLocalStorage.clear();
    }
  };

  const routeClearA = () => {
    if (role === "hospital") {
      secureLocalStorage.clear();
    }
  };

  return (
    <nav className="bg-white fixed top-0  w-full p-2 sm:p-4 md:p-4 lg:p-4 z-50 shadow-lg overflow-x-hidden">
      <div className="max-w-10xl mx-1 sm:mx-2 flex flex-row justify-between items-center px-1 sm:px-2 md:px-1">
        {/* Logo Section */}
        <div className="flex items-center">
          <a href="/">
            <img
              src="/assests/ceviliyar_mainLogo.png"
              alt="Ceviliyar Logo"
              className="w-[145px] h-[36px]"
            />
          </a>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-4">
          <a
            href="#home"
            className="text-[14px] fhd:text-[20px] font-montserrat text-[#0D0D2B] font-bold hover:text-gray-700 no-underline"
          >
            Home
          </a>
          <a
            href="#about"
            className="text-[14px] fhd:text-[20px] font-montserrat text-[#0D0D2B] font-bold hover:text-gray-700 no-underline"
          >
            About
          </a>
          <a
            href="#patient"
            className="text-[14px]  fhd:text-[20px] font-montserrat text-[#0D0D2B] font-bold hover:text-gray-700 no-underline"
          >
            Patient
          </a>
          <a
            href="#nurse"
            className="text-[14px]   fhd:text-[20px] font-montserrat text-[#0D0D2B] font-bold hover:text-gray-700 no-underline"
          >
            Nurse
          </a>
          <a
            href="#physio"
            className="text-[14px]   fhd:text-[20px] font-montserrat text-[#0D0D2B] font-bold hover:text-gray-700 no-underline"
          >
            Physiotherapist
          </a>
          {/* <a
            href="/admin/login"
            className="text-[14px] font-montserrat text-[blue] font-bold hover:text-gray-700 no-underline"
          >
            Admin
          </a> */}
          <div className="bg-custom-gradient rounded-full flex items-center justify-center sm:justify-start">
            <a
              className="text-white text-[11px] sm:text-[12px] lg:text-[13px] font-medium px-3 sm:px-4 py-1 sm:py-1.5 no-underline whitespace-nowrap"
              href="#app"
            >
              Download App
            </a>
          </div>

          <Link
            to="/partner/login"
            onClick={routeClear}
            className="inline-flex items-center gap-1.5 text-[11px] sm:text-[12px] lg:text-[13px] font-montserrat font-medium text-[#1818C3] border border-[#1818C3] hover:bg-[#1818C3] hover:text-white px-3 sm:px-4 py-1 sm:py-1.5 rounded-full transition-all duration-300 no-underline shadow-sm hover:shadow-md whitespace-nowrap"
          >
            <span>Partner Login</span>
            <LogIn size={14} />
          </Link>
        </div>

        <div className="md:hidden flex items-center justify-center">
          <button
            className="text-blue-600 hover:text-blue-500 focus:outline-none"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle navigation menu"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d={
                  isMobileMenuOpen
                    ? "M6 18L18 6M6 6l12 12"
                    : "M4 6h16M4 12h16M4 18h16"
                }
              />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Dropdown Menu */}
      <div
        className={`sm:block md:block lg:hidden transition-all duration-300 ease-in-out ${
          isMobileMenuOpen ? "max-h-screen" : "max-h-0 overflow-hidden"
        }`}
      >
        <div className="bg-white shadow-md pl-2">
          <a
            href="#home"
            className="block px-4 py-2 font-montserrat text-[blue] mt-2 hover:bg-gray-100 no-underline"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Home
          </a>

          <a
            href="#about"
            className="block px-4 py-2 font-montserrat text-[blue] hover:bg-gray-100 no-underline"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            About
          </a>
          <a
            href="#patient"
            className="block px-4 py-2 font-montserrat text-[blue] hover:bg-gray-100 no-underline"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Patient
          </a>
          <a
            href="#nurse"
            className="block px-4 py-2 font-montserrat text-[blue] hover:bg-gray-100 no-underline"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Nurse
          </a>
          <a
            href="#physio"
            className="block px-4 py-2 font-montserrat text-[blue] hover:bg-gray-100 no-underline"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Physiotherapist
          </a>

          <a
            className="block px-4 py-2 font-montserrat text-[purple] hover:bg-gray-100 no-underline"
            href="#app"
          >
            Download App
          </a>

          <Link
            to="/partner/login"
            onClick={() => {
              routeClear();
              setIsMobileMenuOpen(false);
            }}
            className="flex items-center gap-2 px-4 py-2 font-montserrat text-[#1818C3] hover:bg-gray-100 no-underline font-semibold"
          >
            <span>Partner Login</span>
            <LogIn size={16} />
          </Link>

          {/* <a
            href="#admin"
            className="block px-4 py-2 font-montserrat text-[blue] hover:bg-gray-100 no-underline"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Admin
          </a> */}
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
